import { nullUndefined } from '@acri-tools/react-tools/utils';
import React,{Component} from 'react';

import './Counters.css';

interface Props{
    className?:string
    counters: Array<{
        name: string|React.ReactNode
        value: string|React.ReactNode
        unit?: string|React.ReactNode
    }>
}
interface State{
}


export default class Counters extends Component<Props,State>{
    render(){
        return (
            <div className={`counters ${this.props.className || ''}`}>
            {
                this.props.counters.map((counter, idx)=>(
                    <div key={idx} className="counter">
                        <div className="counter-value">
                            { counter.value }
                            {
                                "unit" in counter && !nullUndefined(counter.unit) &&
                                <span className="counter-unit">{counter.unit}</span>
                            }
                        </div>
                        <div className="counter-name">
                            { counter.name }
                        </div>
                    </div>
                ))
            }
            </div>
        );
    }

};